const WorkflowPrepIndex = () => import('@/pages/lab/workflows/prep/WorkflowPrepIndex')
const WorkflowPrepDetail = () => import('@/pages/lab/workflows/prep/WorkflowPrepDetail')
const WorkflowPrepProcessDetail = () => import('@/pages/lab/workflows/prep/WorkflowPrepProcessDetail')
const WorkflowPrepProcessAdd = () => import('@/pages/lab/workflows/prep/WorkflowPrepProcessAdd')
const WorkflowPrepProcessEdit = () => import('@/pages/lab/workflows/prep/WorkflowPrepProcessEdit')
const WorkflowPrepTaskDetail = () => import('@/pages/lab/workflows/prep/WorkflowPrepTaskDetail')
const WorkflowPrepTaskAdd = () => import('@/pages/lab/workflows/prep/WorkflowPrepTaskAdd')
const WorkflowPrepTaskEdit = () => import('@/pages/lab/workflows/prep/WorkflowPrepTaskEdit')

const WorkflowPrepAuditTrail = () => import('@/pages/lab/workflows/prep/WorkflowPrepAuditTrail')
const WorkflowPrepAuditTrailHistory = () => import('@/pages/lab/workflows/prep/WorkflowPrepAuditTrailHistory')
const WorkflowPrepProcessAuditTrail = () => import('@/pages/lab/workflows/prep/WorkflowPrepProcessAuditTrail')
const WorkflowPrepProcessAuditTrailHistory = () => import('@/pages/lab/workflows/prep/WorkflowPrepProcessAuditTrailHistory')
const WorkflowPrepTaskAuditTrail = () => import('@/pages/lab/workflows/prep/WorkflowPrepTaskAuditTrail')
const WorkflowPrepTaskAuditTrailHistory = () => import('@/pages/lab/workflows/prep/WorkflowPrepTaskAuditTrailHistory')

export class PrepWorkflowRoutes {
  constructor () {
    this.route_root = 'prep-workflows'
    this.type_single = 'Prep Workflow'
    this.type_plural = 'Prep Workflows'

    this.routes = [
      {
        path: this.route_root,
        component: { render (c) { return c('router-view') } },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            component: WorkflowPrepIndex,
            meta: { requiresAuth: true }
          },
          {
            path: ':sample_type_id',
            component: { render (c) { return c('router-view') } },
            redirect: ':sample_type_id',
            name: `Prep ${this.type_single}`,
            meta: { requiresAuth: true },
            children: [
              {
                path: '',
                component: WorkflowPrepDetail,
                meta: { requiresAuth: true }
              },
              {
                path: 'audit-trail',
                name: 'Prep Workflow Audit Trail',
                component: WorkflowPrepAuditTrail,
                meta: { requiresAuth: true }
              },
              {
                path: 'audit-trail-history',
                name: 'Prep Workflow Audit Trail History',
                component: WorkflowPrepAuditTrailHistory,
                meta: { requiresAuth: true }
              },
              {
                path: 'add',
                name: 'Add Prep Process',
                component: WorkflowPrepProcessAdd,
                meta: { requiresAuth: true }
              },
              {
                path: ':prep_process_id',
                name: 'Prep Process',
                component: { render (c) { return c('router-view') } },
                redirect: ':prep_process_id',
                meta: { requiresAuth: true },
                children: [
                  {
                    path: '',
                    component: WorkflowPrepProcessDetail,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'edit',
                    name: 'Edit Prep Process',
                    component: WorkflowPrepProcessEdit,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'audit-trail',
                    name: 'Prep Process Audit Trail',
                    component: WorkflowPrepProcessAuditTrail,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'audit-trail-history',
                    name: 'Prep Process Audit Trail History',
                    component: WorkflowPrepProcessAuditTrailHistory,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'add',
                    name: 'Add Prep Task',
                    component: WorkflowPrepTaskAdd,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: ':prep_task_id',
                    name: 'Prep Task',
                    component: { render (c) { return c('router-view') } },
                    redirect: ':prep_task_id',
                    meta: { requiresAuth: true },
                    children: [
                      {
                        path: '',
                        component: WorkflowPrepTaskDetail,
                        meta: { requiresAuth: true }
                      },
                      {
                        path: 'edit',
                        name: 'Edit Prep Task',
                        component: WorkflowPrepTaskEdit,
                        meta: { requiresAuth: true }
                      },
                      {
                        path: 'audit-trail',
                        name: 'Prep Task Audit Trail',
                        component: WorkflowPrepTaskAuditTrail,
                        meta: { requiresAuth: true }
                      },
                      {
                        path: 'audit-trail-history',
                        name: 'Prep Task Audit Trail History',
                        component: WorkflowPrepTaskAuditTrailHistory,
                        meta: { requiresAuth: true }
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }

  static fetchRoutes () {
    const this_obj = new this()
    return this_obj.routes
  }

  static fetchPublicRoutes () {
    const this_obj = new this()
    return this_obj.public_routes
  }

  static fetchRoot () {
    const this_obj = new this()
    return this_obj.route_root
  }
}
